import api from '@/services/api/config';

const path = 'v1/abmusterung/status';

export default {
  get: () => api.get(path),
  getById: (id) => api.get(`${path}/${id}`),
};
